import { Component, Input } from '@angular/core';
import { GameService } from '../../services/game.service';
import { FeedbackService } from '../../services/feedback.service';

@Component({
    selector: 'app-human-text-cloud',
    templateUrl: './human-text-cloud.component.html',
    styleUrls: ['./human-text-cloud.component.scss'],
    standalone: false
})
export class HumanTextCloudComponent {
  @Input() text = '';
  @Input() showEndDateButtons = false;
  @Input() showGoToMissionsButton = false;
  @Input() showFeedbackButton = false;
  @Input() feedbackButtonText = '';
  @Input() bottom = '-10px';

  constructor(
    protected gameService: GameService,
    protected feedbackService: FeedbackService,
  ) {}
}
